import { render, staticRenderFns } from "./MinutesDashboard.vue?vue&type=template&id=2325ae67&"
import script from "./MinutesDashboard.vue?vue&type=script&lang=js&"
export * from "./MinutesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports